import {
  Flex,
  FlexProps,
  RadioItem,
  Section,
  SectionContent,
  SectionTitle,
} from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'

import {
  tEntries,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { PaymentMethod } from '../../../../../state/configuration'

export interface PaymentMethodsProps extends FlexProps {
  options: PaymentMethod[]
  value: PaymentMethod | undefined
  onChange: (method: PaymentMethod) => void
}

export const PaymentMethods: FunctionComponent<PaymentMethodsProps> = ({
  options,
  onChange,
  value,
  ...props
}) => {
  const { t } = useWriskTranslation()

  return (
    <Section>
      <SectionTitle>Payment method</SectionTitle>
      <SectionContent>
        <Flex width={1} variant='raised' flexDirection='column' py={2} {...props}>
          {options.map((option) => (
            <RadioItem
              key={option}
              name={`${option}-payment-method`}
              id={option}
              checked={value === option}
              onChange={onChange}
            >
              {t(tEntries('paymentMethods', option))}
            </RadioItem>
          ))}
        </Flex>
      </SectionContent>
    </Section>
  )
}
